import { render, staticRenderFns } from "./DataCorrection.vue?vue&type=template&id=d286e694"
import script from "./DataCorrection.vue?vue&type=script&lang=js"
export * from "./DataCorrection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports